import React from "react";

import { EntityKind } from "models/entityKind";

import { WellListProvider, initialWellListState } from "components/well-list/context";

import MidstreamNavigator from "./MidstreamNavigator";
import { MidstreamNavigatorProvider } from "./context/MidstreamNavigatorContext";

const MidstreamNavigatorWidget: React.FC = () => {
  return (
    <WellListProvider
      initialState={{ ...initialWellListState, entityKind: EntityKind.Facility }}>
      <MidstreamNavigatorProvider>
        <MidstreamNavigator />
      </MidstreamNavigatorProvider>
    </WellListProvider>
  );
};

export default MidstreamNavigatorWidget;
